import * as Yup from "yup";


export const OtpScheme = Yup.object().shape({
    otp: Yup.string()
      .required('OTP is required')
      .min(4, 'OTP should be 4 digits')
      .max(4, 'OTP should be 4 digits')
      .matches(/^[0-9]*$/, 'OTP should contain only numbers')
  });
  